import { Navigate, Route, Routes } from 'react-router-dom';

import { RawItemsPage } from '@/features/store/RawItemsPage';
import { CafeOrderPage } from './CafeOrderPage';
import { ProductsPage } from './ProductsPage';
import { TaxonomyPage } from './TaxonomyPage';

/**
 * The Cafe area's own routes, mounted under `/cafe/*`.
 *
 * Nested here rather than listed one-by-one in `App.tsx` because that file is
 * appended to by several agents at once (see docs/AGENTS.md) — this keeps the
 * whole area to a single line there.
 *
 * Products and the taxonomy live under `/cafe` even though SPEC §6.3 files
 * them under Settings: the Settings shell is another agent's area, and a
 * screen reachable from the Cafe tab beats a screen wired into a page that
 * does not exist yet. The Settings sub-navigation can link here unchanged.
 */
export function CafeRoutes() {
  return (
    <Routes>
      <Route index element={<CafeOrderPage />} />
      <Route path="products" element={<ProductsPage />} />
      <Route path="taxonomy" element={<TaxonomyPage />} />
      {/* Wave 3 (#17) — raw materials for recipes (agent F's screen). */}
      <Route path="raw-items" element={<RawItemsPage />} />
      <Route path="*" element={<Navigate to="/cafe" replace />} />
    </Routes>
  );
}
